import { writable } from 'svelte/store'

type GrantsStore = {
	open: boolean
	device: {
		[key: string]: any
	}
	params: {
		formType: 'hvac' | 'pv' | null
		houseHeatType?: string | null
		heatingPurpose?: string | null
		annualConsumption?: string | null
		zipcode: string | null
	}
}

export default writable<GrantsStore>({
	open: false,
	device: {},
	params: {
		houseHeatType: null,
		heatingPurpose: null,
		annualConsumption: null,
		zipcode: null,
		formType: null
	}
})
